<template>
    <div class="c-overlay-legal">
        <button class="c-overlay-legal__button" @click="visible=!visible">Note légale</button>
        <div class="c-overlay-legal__text" style="text-align:left;" :class="{'-is-active':visible}">
            <div class="c-overlay-legal__text__inner">
                <p>Véhicule neuf et salle de montre : Les prix à l'achat au comptant, au financement et en location sont basés sur les offres en vigueur publiées par le fabricant. En cas de disparité entre les prix publiés sur les différentes propriétés du groupe et celle du et des fabricants, le prix affiché sur le site du fabricant prévaudra toujours. Les taux d'intérêt sont mis à jour au début de chaque mois et seront valide jusqu'à la fin du mois, en cas de disparité avec le site du et des fabricants, le taux affiché sur le site du fabricant prévaudra. Les taxes sont en sus. Sur approbation du crédit. Des conditions s'appliquent. Tous les détails en concession.</p>
                <p>Véhicule d'occasion : Le taux d’intérêt affiché est à titre indicatif. Veuillez communiquer avec nous pour plus de détails. Les taxes ne sont pas incluses dans le calcul. Sujet à approbation du crédit. Des conditions s’appliquent. Tous les détails en concession. Pour avoir une confirmation du prix exact, le client doit contacter un représentant des ventes ou faire une demande en ligne.</p>
                <p>Bien que tous les efforts raisonnables soient faits pour assurer l’exactitude de ces informations, nous ne sommes pas responsables des erreurs ou omissions contenues sur ces pages.</p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'Note',
    
    data() {
        return {
           visible: false
        }
    },
    computed: {
        
    },
    methods: {
        
    }
}
</script>
